import Chip from "@material-ui/core/Chip";
import { COMPLAIN_STATUS_ACTIVE } from "app/common/LocalConst";
import { memo } from "react";

const PatientComplainChip = ({ complainStatus, className = "" }) => {
  if (complainStatus !== COMPLAIN_STATUS_ACTIVE) {
    return null;
  }

  return (
    <Chip
      label="Đang khiếu nại"
      size="small"
      className={className}
      style={{
        backgroundColor: "#ff8100",
        color: "#fff",
        fontWeight: 600,
        height: 22,
        fontSize: 12,
      }}
    />
  );
};

export default memo(PatientComplainChip);
